// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TaxDrag_DefaultsFragment = { __typename?: 'IncomeTaxDragDefaults', taxYear: number, federalIncomeTaxRate: Percent, federalLongTermCapitalGainsRate: Percent, stateRates: Array<{ __typename?: 'IncomeTaxDragStateRates', stateCode: Types.StateCode, incomeTaxRate: Percent, longTermCapitalGainsRate: Percent }> };

export type TaxDrag_EntityFragment = { __typename?: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'CLTTrust', id: string, displayName: string, currentValue: CurrencyUSD, taxDragTrustStatus?: Types.TrustTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'CRTTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, taxDragNonTrustStatus?: Types.NonTrustEntityTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus, taxDragStateInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string, currentValue: CurrencyUSD, taxDragNonTrustStatus?: Types.NonTrustEntityTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'GPBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'GRATTrust', id: string, displayName: string, currentValue: CurrencyUSD, taxDragTrustStatus?: Types.TrustTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus, taxDragStateInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'ILITTrust', id: string, displayName: string, currentValue: CurrencyUSD, taxDragTrustStatus?: Types.TrustTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus, taxDragStateInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, taxDragNonTrustStatus?: Types.NonTrustEntityTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus, taxDragStateInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, taxDragNonTrustStatus?: Types.NonTrustEntityTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'IrrevocableTrust', id: string, displayName: string, currentValue: CurrencyUSD, taxDragTrustStatus?: Types.TrustTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus, taxDragStateInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'JointPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, taxDragNonTrustStatus?: Types.NonTrustEntityTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus, taxDragStateInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'LPBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'PrivateFoundation', id: string, displayName: string, currentValue: CurrencyUSD, taxDragNonTrustStatus?: Types.NonTrustEntityTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'QPRTTrust', id: string, displayName: string, currentValue: CurrencyUSD, taxDragTrustStatus?: Types.TrustTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, taxDragNonTrustStatus?: Types.NonTrustEntityTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, taxDragNonTrustStatus?: Types.NonTrustEntityTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'RevocableTrust', id: string, displayName: string, currentValue: CurrencyUSD, taxDragTrustStatus?: Types.TrustTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus, taxDragStateInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'SLATTrust', id: string, displayName: string, currentValue: CurrencyUSD, taxDragTrustStatus?: Types.TrustTaxStatus | null, taxDragInEstateStatus: Types.EntityInEstateStatus, taxDragStateInEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } };

export type TaxDragQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type TaxDragQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & TaxDrag_EntityFragment
      ) | null } | null> | null }, households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, isPrimary: boolean, address?: { __typename?: 'Address', id: string, stateCode: string } | null }> } | null } | null> | null } };

export const Operations = {
  Query: {
    TaxDrag: 'TaxDrag' as const
  },
  Fragment: {
    TaxDrag_Defaults: 'TaxDrag_Defaults' as const,
    TaxDrag_Entity: 'TaxDrag_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TaxDrag_DefaultsFragmentDoc = gql`
    fragment TaxDrag_Defaults on IncomeTaxDragDefaults {
  taxYear
  federalIncomeTaxRate
  federalLongTermCapitalGainsRate
  stateRates {
    stateCode
    incomeTaxRate
    longTermCapitalGainsRate
  }
}
    `;
export const TaxDrag_EntityFragmentDoc = gql`
    fragment TaxDrag_Entity on Entity {
  id
  kind
  stage
  subtype {
    id
    displayName
    currentValue
    ... on IrrevocableTrust {
      taxDragTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
      taxDragStateInEstateStatus: stateInEstateStatus
    }
    ... on RevocableTrust {
      taxDragTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
      taxDragStateInEstateStatus: stateInEstateStatus
    }
    ... on SLATTrust {
      taxDragTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
      taxDragStateInEstateStatus: stateInEstateStatus
    }
    ... on ILITTrust {
      taxDragTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
      taxDragStateInEstateStatus: stateInEstateStatus
    }
    ... on GRATTrust {
      taxDragTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
      taxDragStateInEstateStatus: stateInEstateStatus
    }
    ... on QPRTTrust {
      taxDragTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
    }
    ... on CLTTrust {
      taxDragTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
    }
    ... on CustodialPersonalAccount {
      taxDragNonTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
      taxDragStateInEstateStatus: stateInEstateStatus
    }
    ... on DonorAdvisedFund {
      taxDragNonTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
    }
    ... on IndividualPersonalAccount {
      taxDragNonTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
      taxDragStateInEstateStatus: stateInEstateStatus
    }
    ... on InsurancePersonalAccount {
      taxDragNonTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
    }
    ... on JointPersonalAccount {
      taxDragNonTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
      taxDragStateInEstateStatus: stateInEstateStatus
    }
    ... on PrivateFoundation {
      taxDragNonTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
    }
    ... on QualifiedTuitionPersonalAccount {
      taxDragNonTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
    }
    ... on RetirementPersonalAccount {
      taxDragNonTrustStatus: taxStatus
      taxDragInEstateStatus: inEstateStatus
    }
  }
}
    `;
export const TaxDragDocument = gql`
    query TaxDrag($householdId: ID!) {
  entities(where: {hasHouseholdWith: [{id: $householdId}]}) {
    edges {
      node {
        ...TaxDrag_Entity
      }
    }
  }
  households(where: {id: $householdId}, first: 1) {
    edges {
      node {
        id
        possiblePrimaryClients {
          id
          isPrimary
          address {
            id
            stateCode
          }
        }
      }
    }
  }
}
    ${TaxDrag_EntityFragmentDoc}`;

/**
 * __useTaxDragQuery__
 *
 * To run a query within a React component, call `useTaxDragQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxDragQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxDragQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useTaxDragQuery(baseOptions: Apollo.QueryHookOptions<TaxDragQuery, TaxDragQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxDragQuery, TaxDragQueryVariables>(TaxDragDocument, withFetchPolicyContext(options));
      }
export function useTaxDragLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxDragQuery, TaxDragQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxDragQuery, TaxDragQueryVariables>(TaxDragDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useTaxDragSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaxDragQuery, TaxDragQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxDragQuery, TaxDragQueryVariables>(TaxDragDocument, withFetchPolicyContext(options));
        }
export type TaxDragQueryHookResult = ReturnType<typeof useTaxDragQuery>;
export type TaxDragLazyQueryHookResult = ReturnType<typeof useTaxDragLazyQuery>;
export type TaxDragSuspenseQueryHookResult = ReturnType<typeof useTaxDragSuspenseQuery>;
export type TaxDragQueryResult = Apollo.QueryResult<TaxDragQuery, TaxDragQueryVariables>;